module.exports = __webpack_public_path__ + "img/user-group-me_zh.bcd57d39.png";